import { config } from '@psl/functions/config';
import * as Application from 'expo-application';
import * as Devices from 'expo-device';
import { Platform } from 'react-native';

export const getNativeAppVersion = () =>
  Platform.OS === 'web'
    ? config.version
    : Application.nativeApplicationVersion!;

export const getPlatformApiLevel = () => Devices.platformApiLevel ?? 21;

export const isAndroidM = () =>
  Platform.OS === 'android' && getPlatformApiLevel() >= 33;
